// libs
import { styled } from '@nykaa/ui-components';
import { keyframes } from '@emotion/core';

//components
import BaseIcon from 'shared/layouts/Wishlist/components/PriceDrop/Icon';

export const Container = styled.div`
  display: flex;
  ${({ theme }) =>
    `background-color: ${theme.colors.positive10};
    padding: ${theme.spacing.spacing40} ${theme.spacing.spacing80};
    margin-bottom: ${theme.spacing.spacing40};
  `};
`;

export const Text = styled.div`
  ${({ theme }) => theme.typography.subTitleSmall};
  ${({ theme }) => `color: ${theme.colors.primary};`};
`;

const line = keyframes`
    from {
      width: 0px;
      top: 10px;
      left: 7px;
    }
    to {
      width: 9px;
      top: 13px;
      left: 5.5px;
    }
`;

const stroke = keyframes`
    from {
      stroke-dasharray: 11;
      opacity: 1;
    }
    to {
      stroke-dasharray: 21;
      opacity: 1;
    }
`;

const arrow = keyframes`
    from {
      opacity: 0;
    }
    to {    
      opacity: 1;
    }
`;

export const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    height: 1.4px;
    transform: rotate(45deg);
    width: 0px;
    background: ${({ theme }) => theme.colors.positive};
    animation: ${line} 0.5s linear forwards;
  }

  ${({ theme }) =>
    `border-radius: ${theme.borders.radius50};
    background-color: ${theme.colors.surface};
    margin-right: ${theme.spacing.spacing60};
  `};
`;

export const Icon = styled(BaseIcon)`
  animation: ${stroke} 1s 0.6s linear forwards;
  opacity: 0;

  .arrow {
    animation: ${arrow} 0.5s 1.6s linear forwards;
    opacity: 0;
  }
`;
